import { createAsyncThunk } from '@reduxjs/toolkit';

import { actions } from '../actions/environment.action.ts';
import { environmentApi } from '../apis/environment.api';
import {
  ResEnvironmentDaily,
  ResEnvironmentHistories,
  ResEnvironmentMetas,
  ResEnvironmentNow
} from '../models/environment.model.ts';
import qs from 'qs';
import { RootState } from 'modules/rootReducer.ts';

/**
 * Http GET
 * 현재 기상 조회 API
 */
export const getNowEnvironment = createAsyncThunk<ResEnvironmentNow, void>(
  actions.GET_NOW_ENVIRONMENT,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await environmentApi.getNowEnvironment();

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * Http GET
 * 기상 통계 리스트 조회
 */
export const getNowEnvironments = createAsyncThunk<ResEnvironmentMetas, void>(
  actions.GET_NOW_ENVIRONMENTS,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await environmentApi.getNowEnvironments();

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * Http GET
 * 일자별 기상 조회
 */
export const getDailyEnvironment = createAsyncThunk<ResEnvironmentDaily, string>(
  actions.GET_DAILY_ENVIRONMENT,
  async (date, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await environmentApi.getDailyEnvironment(date);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * Http GET
 * 이전 날짜 기상 통계 조회
 */
export const getDailyEnvironments = createAsyncThunk<ResEnvironmentMetas, string>(
  actions.GET_DAILY_ENVIRONMENTS,
  async (date, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await environmentApi.getDailyEnvironments(date);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEnvironmentHistories = createAsyncThunk<
  ResEnvironmentHistories,
  void,
  { state: RootState }
>(actions.GET_ENVIRONMENT_HISTORIES, async (_, { getState, fulfillWithValue, rejectWithValue }) => {
  try {
    const request = getState().environment.fetchEnvironmentHistoriesRequest;
    const query = qs.stringify(request);
    const response = await environmentApi.getEnvironmentHistories(query);

    return fulfillWithValue({ ...response });
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getEnvironmentExcel = createAsyncThunk(
  actions.GET_ENVIRONMENT_EXCEL,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await environmentApi.getEnvironmentExcel(data);

      return fulfillWithValue({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * Http GET
 * 로컬 현지 기상 조회
 */
export const getLocalEnvironmentInfo = createAsyncThunk(
  actions.GET_ENVIRONMENT_LOCAL,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    const response = await environmentApi.getLocalEnvironment();
    const airRes = await environmentApi.getLocalAirPopullution();
    if (!response || !airRes) {
      const error = 'getLocalEnvironmentInfo:: api call failed ' + response;
      console.error(error);
      return rejectWithValue(error);
    } else {
      return fulfillWithValue({
        environment: await response.json(),
        airPopullution: await airRes.json()
      });
    }
  }
);
